import { GapFillerQueryParams } from '@customTypes/GapFiller'
import { InsuranceTypeOptions } from 'src/config/insuranceTypeOptions'
import { Practitioner, PractitionerReferenceId } from '@customTypes/Practitioner'
import { RecallQueryParams } from '@customTypes/Recall'
import { PatientTypeOptions } from 'src/config/patientTypeOptions'
import { getDefaultQueryParams } from './getDefaultQueryParams'
import { getGapFillerQueryParams } from './getGapFillerQueryParams'
import { getRecallQueryParams } from './getRecallQueryParams'
import { NearbyClinicsIdWithTreatmentBundleId } from './useNearbyClinicIdsWithTreatmentBundles'

export type CommonQueryParams = {
  clinicReferenceId: string
  nearbyClinics: NearbyClinicsIdWithTreatmentBundleId
  treatmentBundleTypeReferenceId?: string
  preferredPractitionerReferenceIds?: PractitionerReferenceId[]
  patientType?: PatientTypeOptions
  practitioners: Practitioner[]
  patientReferenceId?: string
  insuranceType?: InsuranceTypeOptions
}

type GetQueryKeyType = (
  commonParams: CommonQueryParams,
  recallQueryParams: RecallQueryParams,
  gapFillerQueryParams: GapFillerQueryParams
) => ReturnType<typeof getRecallQueryParams> | ReturnType<typeof getDefaultQueryParams>

export const getQueryParams: GetQueryKeyType = (commonParams, recallQueryParams, gapFillerQueryParams) => {
  const hasRecallQueryParams = Object.keys(recallQueryParams).length > 0
  if (hasRecallQueryParams) return getRecallQueryParams(commonParams, recallQueryParams)

  const hasGapFillerQueryParams = Object.keys(gapFillerQueryParams).length > 0
  if (hasGapFillerQueryParams) return getGapFillerQueryParams(commonParams, gapFillerQueryParams)

  return getDefaultQueryParams(commonParams)
}
